import { interfaceError } from '../../i18n/errorMessages';
import LocalizedMessage from '../common/LocalizedMessage';
import React from "react";
import {connect} from "react-redux";
import * as PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import {history} from "../../redux/store/configureStore";
import toast from '../../i18n/toast';
import StudentForm from "./StudentForm";
import StudentDuplicateModal from "./StudentDuplicateModal";
import {STATUS} from "../common/Const";
import {validatePerson} from "../common/Validations";
import * as clientActions from "../../redux/actions/clientActions";
import * as studentActions from "../../redux/actions/studentActions";
import {getById} from "../common/Helpers";
import {
  buildManageRouteWithSchoolYear,
  getNormalizedSchoolYearStartYearFromSearch,
} from "./manageSchoolYearRouting";
import { Translation } from 'react-i18next';

const getErrors = validatePerson;

const hasNoErrors = errors => Object.keys(errors).length === 0;

export class Student extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      student: {},
      client: {},
      errors: {},
      touched: {},
      status: STATUS.IDLE,
      saveError: null,
      showDuplicateModal: false,
      duplicateInfo: null,
    };
  }

  componentDidMount() {
    const {clients, client, loadClients, students, student, loadStudents} = this.props;

    if (clients.length === 0) {
      loadClients().catch((error) => {
        toast.error(interfaceError(error, 'common:errors.load'));
      });
    }

    if (students.length === 0) {
      loadStudents().catch((error) => {
        toast.error(interfaceError(error, 'common:errors.load'));
      });
    }

    if (client) this.setClient(client);
    if (student) this.setStudent(student);
  }

  componentDidUpdate(prevProps) {
    const {client, student} = this.props;

    if (client !== prevProps.client) {
      this.setClient(client);
    }
    if (student !== prevProps.student) {
      this.setStudent(student);
    }
  }

  setClient(client) {
    this.setState({ client });
  }

  setStudent(student) {
    this.setState({ student: { ...student } });
  }

  handleBlur = (event) => {
    const { name } = event.target;
    const { touched } = this.state;
    this.setState({ touched: { ...touched, [name]: true } });
    this.validate();
  }

  handleCancel = () => {
    history.push(this.getReturnRoute());
  }

  handleChange = (event) => {
    const {student} = this.state;
    const { name, value } = event.target;
    student[name] = value;
    this.setState({student});
    this.validate();
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ status: STATUS.SUBMITTING });
    const isValid = this.validate();
    if (isValid) {
      const { student } = this.state;
      const { saveStudent, students, clients } = this.props;
      const { checkForDuplicateStudent } = require('../common/Validations');
      const duplicates = checkForDuplicateStudent(student, students, student.id);
      if (duplicates.length) {
        const duplicate = duplicates[0];
        const client = clients.find(item => item.id === duplicate.clientId);
        this.setState({
          showDuplicateModal: true,
          status: STATUS.IDLE,
          duplicateInfo: { ...duplicate, clientName: client ? `${client.firstName} ${client.lastName}` : duplicate.clientId },
        });
        return;
      }
      saveStudent(student)
        .then(() => {
          this.setState({ status: STATUS.COMPLETED });
          toast.success('Dane zostały zapisane');
          history.push(this.getReturnRoute());
        })
        .catch((error) => {
          this.setState({ status: STATUS.SUBMITTED, errors: {saveError: error.message}});
        });
    } else {
      this.setState({ status: STATUS.SUBMITTED });
    }
  }

  handleConfirmFromModal = () => {
    this.setState({ showDuplicateModal: false });
    const { student } = this.state;
    const { saveStudent } = this.props;

    saveStudent(student)
      .then(() => {
        this.setState({ status: STATUS.COMPLETED });
        toast.success('Dane zostały zapisane');
        history.push(this.getReturnRoute());
      })
      .catch((error) => {
        this.setState({ status: STATUS.SUBMITTED, errors: { saveError: error.message }});
      });
  };

  handleCloseDuplicateModal = () => {
    this.setState({ showDuplicateModal: false });
  };

  handleViewParent = (client) => {
    const activeSchoolYearStartYear = getNormalizedSchoolYearStartYearFromSearch(this.props.location.search);
    history.push(buildManageRouteWithSchoolYear(`/manage/client/${client.id}`, this.props.location.search, activeSchoolYearStartYear));
  };

  getReturnRoute() {
    const { location } = this.props;
    const { client, student } = this.state;
    const params = new URLSearchParams(location.search);
    const activeSchoolYearStartYear = getNormalizedSchoolYearStartYearFromSearch(location.search);
    const clientId = client.id || student.clientId;
    const returnTo = params.get("returnTo");

    if (returnTo === "students") {
      return buildManageRouteWithSchoolYear("/manage/students", "", activeSchoolYearStartYear);
    }

    if (clientId) {
      return buildManageRouteWithSchoolYear(`/manage/client/${clientId}`, "", activeSchoolYearStartYear);
    }

    return buildManageRouteWithSchoolYear("/manage/students", "", activeSchoolYearStartYear);
  }

  validate() {
    const { student } = this.state;
    const errors = getErrors(student);
    this.setState({ errors });
    return hasNoErrors(errors);
  }

  render() {
    const {
      student, touched, errors, status, saveError, client
    } = this.state;
    const isValid = hasNoErrors(errors);
    if (saveError) throw saveError;

    return (
      <Translation>{tr => (<div className="mb-5">
        { !isValid && status === STATUS.SUBMITTED && (
          <div role="alert" className="alert alert-danger">
            <p>{tr("manage:pleaseCorrectTheFollowingErrors_348")}</p>
            <ul>
              {Object.keys(errors).map(key => <li key={key}><LocalizedMessage isError value={errors[key]} /></li>)}
            </ul>
          </div>
        )}
        <StudentForm
          firstName={student.firstName}
          lastName={student.lastName}
          email={student.email}
          mobile={student.mobile}
          additionalInfo={student.additionalInfo}
          touched={touched}
          errors={errors}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
          onCancel={this.handleCancel}
          status={status}
          client={client}
          onViewParent={this.handleViewParent}
        />
        <StudentDuplicateModal
          show={this.state.showDuplicateModal}
          duplicateInfo={this.state.duplicateInfo}
          onConfirm={this.handleConfirmFromModal}
          onClose={this.handleCloseDuplicateModal}
        />
      </div>)}</Translation>
    );
  }
}

Student.propTypes = {
  student: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  clients: PropTypes.array.isRequired,
  students: PropTypes.array.isRequired,
  loadClients: PropTypes.func.isRequired,
  loadStudents: PropTypes.func.isRequired,
  saveStudent: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const {id} = ownProps.match.params;
  const clientId = new URLSearchParams(ownProps.location.search).get('clientId');
  const student = id === "new" || state.students.length === 0
    ? {clientId}
    : getById(state.students, id);
  const client = !student || !student.clientId || state.clients.length === 0
    ? {}
    : getById(state.clients, student.clientId);
  return {
    client,
    student,
    clients: state.clients,
    students: state.students,
  };
};

const mapDispatchToProps = dispatch => ({
  loadClients: () => dispatch(clientActions.loadClients()),
  loadStudents: () => dispatch(studentActions.loadStudents()),
  saveStudent: student => dispatch(studentActions.saveStudent(student)),
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Student));
